module.exports = __webpack_public_path__ + "img/logo_small.bea56bbd.png";